import { render, staticRenderFns } from "./QuestionText.vue?vue&type=template&id=08437668&scoped=true&"
import script from "./QuestionText.vue?vue&type=script&lang=js&"
export * from "./QuestionText.vue?vue&type=script&lang=js&"
import style0 from "./QuestionText.vue?vue&type=style&index=0&id=08437668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08437668",
  null
  
)

export default component.exports